<template>
  <div class="container preload">
    <div class="creditcard">
      <div class="front">
        <svg
          version="1.1"
          id="cardfront"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 750 471"
          style="enable-background: new 0 0 750 471"
          xml:space="preserve"
        >
          <g id="Front" :class="{ Front: newAcc }">
            <g id="CardBackground">
              <g id="Page-1_1_">
                <g id="amex_1_">
                  <path
                    id="Rectangle-1_1_"
                    class="lightcolor grey"
                    d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                            C0,17.9,17.9,0,40,0z"
                  />
                </g>
              </g>
              <path
                class="darkcolor greydark"
                d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z"
              />
            </g>
            <!-- <text   transform="matrix(1 0 0 1 60.106 295.0121)" id="svgnumber"  class="st2 st3 st4">XXXX XXXX XXXX XXXX</text> -->
            <foreignObject
              transform="matrix(1 0 0 1 60.106 295.0121)"
              width="80%"
              height="150"
            >
              <input
                v-if="!newAcc"
                v-model="number"
                class="inputCardNumberClass"
                v-maska="'#### #### #### ####'"
                disabled
              />
              <div v-else class="add" @click="newAccount">+</div>
            </foreignObject>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { maska } from "maska";
export default {
  directives: { maska },
  props: {
    cardNumber: String,
    bankAccountNumber: String,
  },
  computed: {
    newAcc() {
      if (this.cardNumber != "new") {
        return false;
      }
      return true;
    },
    number() {
      if (this.cardNumber != null) {
        return this.cardNumber;
      }
      return this.bankAccountNumber;
    },
  },
  data() {
    return {};
  },
  methods: {
    newAccount() {
      this.$emit("newAccount");
    },
  },
};
</script>

<style scoped>
.add {
  font-size: 76px;
  color: #000;
  border: 2px solid;
  border-radius: 100px;
}
.inputCardNumberClass {
  background: none;
  border: none;
  font-size: 58px;
  padding: 0;
}
.inputCardNumberClass:focus {
  background: none;
  border: none;
  font-size: 58px;
  outline: none;
  padding: 0;
}
.inputName {
  width: 90%;
  direction: rtl;
}
.ccicon {
  height: 38px;
  position: absolute;
  right: 6px;
  top: calc(50% - 17px);
  width: 60px;
}

/* CREDIT CARD IMAGE STYLING */
.preload * {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -ms-transition: none !important;
  -o-transition: none !important;
}

.container {
  width: 100%;
  max-width: 400px;
  max-height: 251px;
  height: 54vw;
  margin-top: 20px;
}

#ccsingle {
  position: absolute;
  right: 15px;
  top: 20px;
}

#ccsingle svg {
  width: 100px;
  max-height: 60px;
}

.creditcard svg#cardfront,
.creditcard svg#cardback {
  width: 100%;
  -webkit-box-shadow: 1px 5px 6px 0px black;
  box-shadow: 1px 5px 6px 0px black;
  border-radius: 22px;
}

#generatecard {
  cursor: pointer;
  float: right;
  font-size: 12px;
  color: #fff;
  padding: 2px 4px;
  background-color: #909090;
  border-radius: 4px;
  cursor: pointer;
  float: right;
}

/* CHANGEABLE CARD ELEMENTS */
.creditcard .lightcolor,
.creditcard .darkcolor {
  -webkit-transition: fill 0.5s;
  transition: fill 0.5s;
}

.creditcard .lightblue {
  fill: #03a9f4;
}

.creditcard .lightbluedark {
  fill: #0288d1;
}

.creditcard .red {
  fill: #ef5350;
}

.creditcard .reddark {
  fill: #d32f2f;
}

.creditcard .purple {
  fill: #ab47bc;
}

.creditcard .purpledark {
  fill: #7b1fa2;
}

.creditcard .cyan {
  fill: #26c6da;
}

.creditcard .cyandark {
  fill: #0097a7;
}

.creditcard .grey {
  fill: #000;
}

.creditcard .greydark {
  fill: #616161;
}

/* FRONT OF CARD */
#svgname {
  text-transform: uppercase;
}

#cardfront .st2 {
  fill: #ffffff;
}

#cardfront .st3 {
  font-family: "Source Code Pro", monospace;
  font-weight: 600;
}

#cardfront .st4 {
  font-size: 54.7817px;
}

#cardfront .st5 {
  font-family: "Source Code Pro", monospace;
  font-weight: 400;
}

#cardfront .st6 {
  font-size: 33.1112px;
}

#cardfront .st7 {
  opacity: 0.6;
  fill: #ffffff;
}

#cardfront .st8 {
  font-size: 24px;
}

#cardfront .st9 {
  font-size: 36.5498px;
}

#cardfront .st10 {
  font-family: "Source Code Pro", monospace;
  font-weight: 300;
}

#cardfront .st11 {
  font-size: 16.1716px;
}

#cardfront .st12 {
  fill: #4c4c4c;
}
.Front {
  opacity: 0.5;
}
</style>
